import { useParams } from 'react-router';
import { useSelector } from 'react-redux';

export default () => {
  const { institutionId } = useParams();
  const { institutions } = useSelector(state => state.institutions);
  const selectedInstitution = institutions.find(
    ({ id }) => parseInt(id) === parseInt(institutionId)
  );

  return {
    institutionId: institutionId,
    institutionName: selectedInstitution?.name,
    mainUser: selectedInstitution?.mainUser,
  };
};
